module.exports = __webpack_public_path__ + "img/XL_QUITTER.c1f5f177.svg";